import { ComparisonItemDAO, BMOGIFItemDAO } from './ProposalItemDAO';
import { ProposalFieldDAO } from './ProposalFieldDAO';
import { ScatterPlotOptions } from '../components/views/ProposalScatterPlot';
import * as ProposalNS from '../Proposal';
import Nullable from '@/types/nullable';
import Dictionary from '@/types/dictionary';
import ProposalTableData from '@/types/proposal-table-data';
import SeriesData from '@/types/series-data';
import LineSeriesData from '@/types/line-series-data';
import ScatterPlotData from '@/types/scatter-plot-data';
import DonutData from '@/types/donut-data';
import ProposalToolbarOption from '@/types/proposal-toolbar-option';
import ComparisonItem from '@/types/comparison-item';
import LocalizedString from '@/types/localized-string';

export class ProposalDAOFieldName {
  fieldName: string;

  className: string;

  constructor(fieldName: string, className: string) {
    this.fieldName = fieldName;
    this.className = className;
  }
}

export enum ProposalDAOInterfaces {
  ComparisonItem,
  BMOGIF,
  ItemFields,
  TableData,
  Data,
  Texts,
  TextArea,
  ToolbarOption,
  ScatterChartOptions,
  TableOfContents,
}

export interface ProposalDAOInterface {
  buildDAO(): void;

  // interface
  getInterface<T>(id: number): T | undefined;

  // method
  getColorsDict(): Nullable<Dictionary<string>>;
}

export type DisclaimerConfig = {
  key: string;
  config: any;
  items: ComparisonItem[];
};

export interface ComparisonItemBasedProposalDAOInterface extends ProposalDAOInterface {
  // item access
  getItemDAOs(): Array<ComparisonItemDAO>;

  // Disclaimer configs
  getDisclaimerConfigs(): Array<DisclaimerConfig>;

  setSectionIteratorIndex(index: Nullable<number>): void;

  getSectionIteratorIndex(): Nullable<number>;
}

export interface BMOGIFBasedProposalDAOInterface extends ProposalDAOInterface {
  // item access
  getItemDAOs(): Array<BMOGIFItemDAO>;
}

export interface ProposalItemFieldsDAOInterface extends ProposalDAOInterface {
  getItemFields(index?: number): ProposalFieldDAO[];
}

export interface ProposalTableDataDAOInterface extends ProposalDAOInterface {
  getTableData(skipRows?: number, limitRows?: number): ProposalTableData;

  getTableClassName(): string;

  tableOrientationOptions: ProposalNS.TableOrientationDAOOptions | null;
}

export interface ProposalDataDAOInterface extends ProposalDAOInterface {
  getSeriesData(): SeriesData[][];

  getGraphConfigOptions(): ProposalNS.ChartConfigOptions;

  getLineSeries(): LineSeriesData[];

  getScatterSeries(): ScatterPlotData[];

  getDonutData(index?: number): DonutData | null;
}

export interface ProposalTextsDAOInterface extends ProposalDAOInterface {
  getTexts(metadata?: ProposalNS.DAOGetTextsMetadata): Array<{ text: string; className?: string; _id?: string }>;
}

export interface ProposalTextAreaDAOInterface extends ProposalDAOInterface {
  getTextAreaInitialValue(defaultValue?: LocalizedString): string | undefined;
}

export interface ProposalToolbarOptionDAOInterface extends ProposalDAOInterface {
  getToolbarOption(): ProposalToolbarOption | undefined;
}

export interface ProposalScatterChartOptionsDAOInterface extends ProposalDAOInterface {
  getScatterChartOptions(): ScatterPlotOptions;
}
